<template>
  <div class="content-tags" v-html="enrichedHtml"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { enrichContentTagsHtml } from '@/js/utils/enrich-content-tags-html';

const props = defineProps<{
  html: string;
}>();

const enrichedHtml = computed(() => enrichContentTagsHtml(props.html));
</script>
